/* eslint-disable import/no-cycle */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import {
  getConfirmationFlow,
  isKilometersPlanPrice,
} from 'domains/quotation/utils/get-confirmation-flow';
import { AppContext } from 'domains/commons/contexts/global/global-provider';
import { setModalEditState } from 'domains/quotation/hooks/use-modal-edit';
import { ROUTES } from 'libs/constants/routes';
import ImageRightSidebar from '../../../assets/images/svg/img-right-sidebar.svg';
import iconEdit from '../../../assets/images/svg/icon-edit-black.svg';
import './summary.scss';
import { DataLayer } from 'libs/providers/datalayer/datalayer';
import {
  globalFlow,
  VIRTUAL_EVENT_ACTIONS,
  VIRTUAL_EVENT_CATEGORIES,
  VIRTUAL_EVENT_SECTION,
  VIRTUAL_EVENT_SUB_ZONE,
  VIRTUAL_EVENT_TYPE_ELEMENT,
  VIRTUAL_EVENT_TYPE_EVENT,
  VIRTUAL_EVENT_TYPE_ZONE,
  VIRTUAL_EVENT_ZONE,
} from 'libs/providers/datalayer/constants';
import env from 'libs/constants/env';
import downloadIcon from 'assets/images/svg/quotation/confirmation-coverage.svg';
import { getURLRedirectChannelPage } from 'libs/utils/redirectChannel';

const Summary: React.FC<{ editVehicle: boolean }> = ({ editVehicle }) => {
  const navigateTo = useNavigate();
  const { channel = null } = useParams();
  const [showEdit] = useState(true);
  const location = useLocation();

  const {
    store: {
      vehicle,
      customer,
      plan,
      quotation,
      request,
      dataLayer,
      mirrorPage,
    },
  } = useContext(AppContext);

  const handleClickCoveragesExclusionsBtn = () => {
    DataLayer.setVirtualEvent({
      category: 'Seguro Vehicular',
      action: VIRTUAL_EVENT_ACTIONS.resumen,
      label: `Clic - Botón - Coberturas y exclusiones`,
      flujo: getConfirmationFlow(dataLayer),
    });
  };

  const handleClickEdit = (type: any) => {
    DataLayer.setVirtualEvent({
      category: VIRTUAL_EVENT_CATEGORIES.default,
      action:
        location.pathname === ROUTES.STEP2 ||
        location.pathname === ROUTES.STEP2_MIRROW
          ? VIRTUAL_EVENT_ACTIONS.cotizacion
          : VIRTUAL_EVENT_ACTIONS.resumen,
      label: `link - Actualizar datos`,
      tipoZona: VIRTUAL_EVENT_TYPE_ZONE.autos,
      zona: VIRTUAL_EVENT_ZONE.nuevo,
      subZona:
        location.pathname === ROUTES.STEP2 ||
        location.pathname === ROUTES.STEP2_MIRROW
          ? VIRTUAL_EVENT_SUB_ZONE.paso1
          : VIRTUAL_EVENT_SUB_ZONE.paso2,
      sección: VIRTUAL_EVENT_SECTION.formulario,
      tipoEvento: VIRTUAL_EVENT_TYPE_EVENT.click,
      tipoElemento: VIRTUAL_EVENT_TYPE_ELEMENT.link,
      valor: 'Actualizar datos',
      flujo: globalFlow(dataLayer),
    });

    if (type === 'plan') {
      const params = new URLSearchParams(window.location.search);
      params.append('edit', '1');
      navigateTo({
        pathname: mirrorPage.active
          ? ROUTES.STEP2_MIRROW
          : getURLRedirectChannelPage('cotizacion', channel!),
        search: params.toString(),
      });
      return;
    }

    setModalEditState({
      open: true,
      type,
    });
  };

  const { annualFixedPremiumGps, totalPremium } = quotation;
  const priceForPlan = isKilometersPlanPrice(
    annualFixedPremiumGps,
    totalPremium,
    plan.offerCode,
  );

  const summaryInfo = {
    vehicle: {
      model: `${vehicle.brand?.description} ${vehicle.model?.standard} ${vehicle.year}`,
      plate: vehicle?.plate?.toUpperCase() || 'No tengo placa',
      sumInsured: vehicle.sumInsured?.estimated,
    },
    customer: {
      fullName: `${customer.names} ${customer.firstSurname ?? ''} ${
        customer.lastSurname ?? ''
      }`,
      documentType: customer.documentType,
      documentId: customer.documentId,
      mobile: customer.mobile?.replace(/(\d{3})/g, '$1 '),
      email: customer.email,
    },
    quotation: {
      planName: `${plan.type} ${plan.title}`,
      monthlyPay: plan.price.toLocaleString(),
      yearlyPay: priceForPlan?.toLocaleString(),
      quotas: quotation.quotas,
      initDate: dayjs(request.coverageStartDate).format('DD/MM/YYYY'),
      offerCode: quotation.offerCode,
    },
  };

  return (
    <>
      <div className="summary-content" data-testid="summary-content">
        <div className="summary-content__data">
          <p className="summary-content__data-title">
            <b>Resumen de tu compra</b>
          </p>
          <div className="summary-content__data-content">
            {quotation.quotas && (
              <>
                <div>
                  <p className="summary-content__data-subtitle">
                    <b>Sobre tu seguro</b>
                  </p>
                  {showEdit && (
                    <img
                      src={iconEdit}
                      alt="icon edit"
                      className="summary-btn-edit"
                      onClick={() => handleClickEdit('plan')}
                    />
                  )}
                </div>
                <p className="summary-content__data-name">
                  {summaryInfo.quotation.planName}
                </p>
                <div>
                  <p className="summary-content__data-information">
                    Pago mensual (incl. IGV)
                  </p>
                  <p className="summary-content__data-description">
                    ${summaryInfo.quotation.monthlyPay}
                  </p>
                </div>
                <div>
                  <p className="summary-content__data-information">
                    Pago total
                  </p>
                  <p className="summary-content__data-description">
                    ${summaryInfo.quotation.yearlyPay}
                  </p>
                </div>
                <div>
                  <p className="summary-content__data-information">
                    Número de cuotas
                  </p>
                  <p className="summary-content__data-description">
                    {summaryInfo.quotation.quotas}
                  </p>
                </div>
                <div>
                  <p className="summary-content__data-information">
                    Fecha de inicio del seguro
                  </p>
                  <p className="summary-content__data-description">
                    {summaryInfo.quotation.initDate}
                  </p>
                </div>
              </>
            )}
          </div>
          <div className="summary-content__data-content">
            {customer.names && (
              <>
                <div>
                  <p className="summary-content__data-subtitle">
                    <b>Datos personales</b>
                  </p>
                  {showEdit && (
                    <img
                      src={iconEdit}
                      alt="icon edit"
                      onClick={() => handleClickEdit('customer')}
                      className="summary-btn-edit"
                    />
                  )}
                </div>
                <p className="summary-content__data-name">
                  {summaryInfo.customer.fullName}
                </p>
                <div>
                  <p className="summary-content__data-information">
                    Documento de identidad ({summaryInfo.customer.documentType})
                  </p>
                  <p className="summary-content__data-description">
                    {summaryInfo.customer.documentId}
                  </p>
                </div>
                <div>
                  <p className="summary-content__data-information">Celular </p>
                  {summaryInfo.customer.mobile && (
                    <p className="summary-content__data-description">
                      {summaryInfo.customer.mobile}
                    </p>
                  )}
                </div>
                <div>
                  <p className="summary-content__data-information">Correo </p>
                  {summaryInfo.customer.email && (
                    <p className="summary-content__data-description">
                      {summaryInfo.customer.email}
                    </p>
                  )}
                </div>
              </>
            )}
          </div>
          <div className="summary-content__data-content">
            {vehicle.sumInsured && vehicle.sumInsured.estimated && (
              <>
                <div>
                  <p className="summary-content__data-subtitle">
                    <b>Sobre tu vehículo</b>
                  </p>
                  {showEdit && (
                    <img
                      src={iconEdit}
                      alt="icon edit"
                      onClick={() => handleClickEdit('vehicle')}
                      className="summary-btn-edit"
                    />
                  )}
                </div>
                <p className="summary-content__data-name">
                  {summaryInfo.vehicle.model}
                </p>
                <div>
                  <p className="summary-content__data-information">Placa</p>
                  <p className="summary-content__data-description">
                    {summaryInfo.vehicle.plate}
                  </p>
                </div>
                <div>
                  <p className="summary-content__data-information">
                    Valor del Vehículo
                  </p>
                  <p className="summary-content__data-description">
                    ${summaryInfo.vehicle.sumInsured}
                  </p>
                </div>
              </>
            )}
          </div>
          <br />
          <div className="button-white">
            <a
              href={`${window.location.origin}${env.PUBLIC_URL}/documents/Documento_Vehicular.pdf`}
              target="_blank"
              rel="noreferrer"
              onClick={handleClickCoveragesExclusionsBtn}
            >
              <img src={downloadIcon} alt="download-icon" />
              Coberturas y exclusiones
            </a>
          </div>
        </div>
        <div className="summary-content__image">
          <img src={ImageRightSidebar} alt="sidebar" />
        </div>
      </div>
    </>
  );
};
export default Summary;
